module.exports = __webpack_public_path__ + "static/img/mb-vans-land-big.c1beff9c.jpg";